(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arma-tu-kit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__tpk) return;
      root.__tpk = true;

      var ids = (root.dataset.ids || '').split(',').map(Number);
      var items = Array.prototype.slice.call(root.querySelectorAll('.tpk__item'));
      var niveles = Array.prototype.slice.call(root.querySelectorAll('.tpk__nivel'));
      var bar = root.querySelector('.tpk__bar');
      var slotsEl = root.querySelector('.tpk__slots');
      var estadoEl = root.querySelector('.tpk__estado');
      var cta = root.querySelector('.tpk__cta');
      var errEl = root.querySelector('.tpk__error');
      var enCarritoEl = root.querySelector('.tpk__encarrito');
      var sel = {};           // variantId -> cantidad elegida aquí
      var enCarrito = 0;      // perfumes de la promo que ya están en el carrito
      var preciosCarrito = []; // precio (centavos) de cada perfume de la promo en el carrito
      var totalAntesEl = root.querySelector('.tpk__total-antes');
      var totalAhoraEl = root.querySelector('.tpk__total-ahora');
      var ahorroEl = root.querySelector('.tpk__total-ahorro');
      var reglas = niveles.map(function (n) {
          var cant = Number(n.dataset.meta) || 0;
          var m = String(n.dataset.nombre || '').match(/(\d+)\s*[x×]\s*(\d+)/i);   // "5x3" → se pagan 3
          var paga = m ? Number(m[2]) : (Number(n.dataset.paga) || cant);
          return { cantidad: cant, gratis: Math.max(0, cant - paga) };
        })
        .filter(function (r) { return r.cantidad > 0; })
        .sort(function (a, b) { return b.cantidad - a.cantidad; });
      function dinero(c) {
        var v = Math.round(c) / 100;
        return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
      }
      var filtro = { genero: 'todos', familia: 'todas' };

      // ----- Nivel (promo) -----
      var qsNivel = new URLSearchParams(location.search).get('nivel');
      var nivelActivo = niveles.filter(function (n) { return n.classList.contains('is-on'); })[0] || niveles[0];
      if (qsNivel) niveles.forEach(function (n) { if (n.dataset.meta === qsNivel) nivelActivo = n; });
      function setNivel(n) {
        nivelActivo = n;
        niveles.forEach(function (x) { var on = x === n; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        render();
      }
      niveles.forEach(function (n) { n.addEventListener('click', function () { setNivel(n); }); });
      if (nivelActivo) setNivel(nivelActivo);

      function meta() { return nivelActivo ? Number(nivelActivo.dataset.meta) || 3 : 3; }
      function nombreNivel() { return nivelActivo ? nivelActivo.dataset.nombre : ''; }
      function elegidos() { return Object.keys(sel).reduce(function (s, k) { return s + sel[k]; }, 0); }

      // ----- Filtros -----
      root.querySelectorAll('[data-genero]').forEach(function (b) {
        if (b.tagName !== 'BUTTON') return;
        b.addEventListener('click', function () {
          filtro.genero = b.dataset.genero;
          root.querySelectorAll('.tpk__seg button').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          aplicarFiltros();
        });
      });
      root.querySelectorAll('.tpk__chip').forEach(function (b) {
        b.addEventListener('click', function () {
          filtro.familia = b.dataset.familia;
          root.querySelectorAll('.tpk__chip').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          aplicarFiltros();
        });
      });
      function aplicarFiltros() {
        var visibles = 0;
        items.forEach(function (it) {
          var okG = filtro.genero === 'todos' || (' ' + it.dataset.genero + ' ').indexOf(' ' + filtro.genero + ' ') !== -1;
          var okF = filtro.familia === 'todas' || it.dataset.familia === filtro.familia;
          var ver = okG && okF;
          it.hidden = !ver;
          if (ver) visibles++;
        });
        root.querySelector('.tpk__vacio').hidden = visibles > 0;
      }

      // ----- Selección -----
      items.forEach(function (it) {
        var v = it.dataset.variant;
        var add = it.querySelector('[data-add]');
        if (!add) return;
        add.addEventListener('click', function () { cambiar(it, 1); });
        it.querySelector('[data-mas]').addEventListener('click', function () { cambiar(it, 1); });
        it.querySelector('[data-menos]').addEventListener('click', function () { cambiar(it, -1); });
      });
      function cambiar(it, d) {
        var v = it.dataset.variant;
        sel[v] = Math.max(0, (sel[v] || 0) + d);
        if (!sel[v]) delete sel[v];
        var n = sel[v] || 0;
        it.classList.toggle('is-sel', n > 0);
        it.querySelector('[data-add]').hidden = n > 0;
        it.querySelector('.tpk__stepper').hidden = n === 0;
        it.querySelector('[data-cant]').textContent = n;
        it.querySelector('.tpk__qtybadge').textContent = n;
        if (d > 0 && n === 1) { var mas = it.querySelector('[data-mas]'); if (mas) mas.focus(); }
        render();
      }

      // ----- Barra -----
      function render() {
        var m = meta(), e = elegidos(), total = enCarrito + e, faltan = Math.max(0, m - total);
        var imgs = [];
        items.forEach(function (it) { var n = sel[it.dataset.variant] || 0; for (var i = 0; i < n; i++) imgs.push(it.dataset.img); });
        var html = '';
        var slots = Math.max(m, total);
        for (var i = 0; i < slots; i++) {
          if (i < enCarrito) html += '<span class="tpk__slot is-cart" title="Ya en tu carrito">✓</span>';
          else if (i - enCarrito < imgs.length) html += '<span class="tpk__slot is-full" style="background-image:url(' + imgs[i - enCarrito] + ')"></span>';
          else html += '<span class="tpk__slot">' + (i + 1) + '</span>';
        }
        slotsEl.innerHTML = html;

        if (faltan > 0) {
          estadoEl.innerHTML = '<strong>' + total + ' de ' + m + '</strong> · Elige ' + faltan + ' perfume' + (faltan > 1 ? 's' : '') + ' más para tu ' + nombreNivel();
          cta.disabled = true;
          cta.classList.remove('is-ready');
          cta.textContent = e === 0 && enCarrito === 0 ? root.dataset.tVacio : root.dataset.tParcial;
        } else {
          estadoEl.innerHTML = '<strong>¡Listo! Tu ' + nombreNivel() + ' está completo</strong> · Los regalos se agregan solos';
          cta.disabled = false;
          cta.classList.add('is-ready');
          cta.textContent = e === 0 ? root.dataset.tCarrito : root.dataset.tCompleto.replace('[nivel]', nombreNivel());
        }
        // ----- Total en dinero (la promo regala los perfumes más baratos) -----
        var precios = preciosCarrito.slice();
        items.forEach(function (it) { var n = sel[it.dataset.variant] || 0; for (var i = 0; i < n; i++) precios.push(Number(it.dataset.price) || 0); });
        var antes = precios.reduce(function (s, p) { return s + p; }, 0);
        var gratis = 0;
        for (var r = 0; r < reglas.length; r++) { if (precios.length >= reglas[r].cantidad) { gratis = reglas[r].gratis; break; } }
        var ordenados = precios.slice().sort(function (a, b) { return a - b; });
        var descuento = ordenados.slice(0, gratis).reduce(function (s, p) { return s + p; }, 0);
        totalAhoraEl.textContent = dinero(antes - descuento);
        totalAntesEl.textContent = dinero(antes);
        totalAntesEl.hidden = descuento === 0;
        ahorroEl.textContent = 'Ahorras ' + dinero(descuento);
        ahorroEl.hidden = descuento === 0;

        enCarritoEl.hidden = enCarrito === 0;
        enCarritoEl.innerHTML = 'Ya tienes <strong>' + enCarrito + ' perfume' + (enCarrito > 1 ? 's' : '') + '</strong> de la promo en tu carrito. Cuentan para tu kit.';
      }

      function abrirCarrito() {
        var d = document.querySelector('cart-drawer-component');
        if (root.dataset.modo === 'drawer' && d && d.open) {
          fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var ev = new Event('cart:update', { bubbles: true });
            ev.detail = { resource: cart, sourceId: 'tp-kit', data: { source: 'tp-kit', itemCount: cart.item_count } };
            document.dispatchEvent(ev);
            d.open();
          });
        } else if (root.dataset.modo === 'checkout') {
          location.href = '/checkout';
        } else {
          location.href = root.dataset.cartUrl || '/cart';
        }
      }

      cta.addEventListener('click', function () {
        var lista = Object.keys(sel).map(function (v) { return { id: Number(v), quantity: sel[v] }; });
        if (!lista.length) { abrirCarrito(); return; }
        cta.disabled = true; errEl.hidden = true;
        var txt = cta.textContent; cta.textContent = 'Agregando…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: lista })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'No se pudo agregar'); return j; }); })
          .then(function () {
            items.forEach(function (it) { if (sel[it.dataset.variant]) { sel[it.dataset.variant] = 0; } });
            Object.keys(sel).forEach(function (k) { delete sel[k]; });
            items.forEach(function (it) { it.classList.remove('is-sel'); var a = it.querySelector('[data-add]'); if (a) { a.hidden = false; it.querySelector('.tpk__stepper').hidden = true; } });
            return leerCarrito();
          })
          .then(function () { cta.textContent = txt; abrirCarrito(); })
          .catch(function (e) { errEl.textContent = e.message; errEl.hidden = false; cta.disabled = false; cta.textContent = txt; });
      });

      function leerCarrito() {
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            preciosCarrito = [];
            cart.items.forEach(function (it) {
              var regalo = it.properties && it.properties._regalo;
              if (regalo || ids.indexOf(it.product_id) === -1) return;
              for (var q = 0; q < it.quantity; q++) preciosCarrito.push(it.original_price || it.price);
            });
            enCarrito = preciosCarrito.length;
            render();
          }).catch(function () {});
      }

      document.addEventListener('cart:update', function (e) { if (!e.detail || e.detail.sourceId !== 'tp-kit') setTimeout(leerCarrito, 400); });
      aplicarFiltros();
      render();
      leerCarrito();
    }

    function initAll() { document.querySelectorAll('[data-tpk]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cross-sell-centeniall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xf-cross')) {
    class XfCross extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.querySelectorAll('[data-atc-form]').forEach((form) => {
          form.addEventListener('submit', (event) => this.add(event, form), opts);
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      async add(event, form) {
        const button = form.querySelector('[data-atc-button]');
        if (!button || typeof fetch !== 'function') return;
        event.preventDefault();

        const original = button.dataset.label || button.textContent.trim();
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;

        try {
          const response = await fetch(this.dataset.addUrl || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('HTTP ' + response.status);

          button.textContent = this.dataset.added || 'Agregado';

          const cart = await fetch(this.dataset.cartUrl || '/cart.js', { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null);

          ['cart:refresh', 'cart:updated', 'cart:build'].forEach((name) => {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart } }));
          });
          document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { cart } }));

          if (this.dataset.redirect === 'true') {
            window.location.href = this.dataset.cartPage || '/cart';
            return;
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();

          setTimeout(() => {
            button.textContent = original;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }, 2000);
        } catch (error) {
          console.error('No se pudo agregar al carrito:', error);
          button.disabled = false;
          button.removeAttribute('aria-busy');
          form.submit();
        }
      }
    }

    customElements.define('xf-cross', XfCross);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-olfativo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mo-menu')) {
    class MoMenu extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('[data-filter]'));
        this.rows = Array.from(this.querySelectorAll('[data-row]'));
        this.empty = this.querySelector('[data-empty]');
        this.counter = this.querySelector('[data-count]');
        this.live = this.querySelector('[data-live]');
        if (this.rows.length === 0) return;

        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => this.apply(chip), opts);
        });

        this.update(this.rows.length);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      apply(chip) {
        const value = chip.dataset.value || '';
        this.chips.forEach((other) => {
          other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
        });

        let shown = 0;
        this.rows.forEach((row) => {
          const match = !value || value === 'todas' || row.dataset.genero === value;
          row.hidden = !match;
          if (match) shown += 1;
        });

        this.update(shown);
      }

      update(shown) {
        if (this.empty) this.empty.hidden = shown !== 0;
        const template = this.dataset.countText || '[n] fragancias';
        const text = template.replace('[n]', shown);
        if (this.counter) this.counter.textContent = text;
        if (this.live) this.live.textContent = text;
      }
    }

    customElements.define('mo-menu', MoMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-centeniall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-carousel')) {
    class PsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.slides = Array.from(this.track.querySelectorAll('.ps__slide'));
        if (this.slides.length === 0) return;

        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pauseBtn = this.querySelector('[data-pause]');
        this.index = 0;
        this.userPaused = false;
        this.hovering = false;
        this.visible = true;
        this.timer = null;
        this.controller = new AbortController();

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.wantsAutoplay = this.dataset.autoplay === 'true' && !this.reduced && this.slides.length > 1;
        this.interval = Math.max(3000, parseInt(this.dataset.interval, 10) || 5000);

        const opts = { signal: this.controller.signal };

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); }, opts);
        if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); }, opts);

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.go(parseInt(dot.dataset.index, 10) || 0);
            this.restart();
          }, opts);
        });

        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
            this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Reanudar el carrusel' : 'Pausar el carrusel');
            this.sync();
          }, opts);
        }

        this.addEventListener('mouseenter', () => { this.hovering = true; this.sync(); }, opts);
        this.addEventListener('mouseleave', () => { this.hovering = false; this.sync(); }, opts);
        this.addEventListener('focusin', () => { this.hovering = true; this.sync(); }, opts);
        this.addEventListener('focusout', () => {
          if (!this.contains(document.activeElement)) { this.hovering = false; this.sync(); }
        }, opts);
        this.track.addEventListener('pointerdown', () => { this.hovering = true; this.sync(); }, opts);

        document.addEventListener('visibilitychange', () => {
          this.visible = document.visibilityState === 'visible';
          this.sync();
        }, opts);

        let raf = null;
        this.track.addEventListener('scroll', () => {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.readIndex());
        }, opts);

        window.addEventListener('resize', () => this.refresh(), opts);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              this.visible = entry.isIntersecting && document.visibilityState === 'visible';
              this.sync();
            }
          }, { threshold: 0.25 });
          this.observer.observe(this);
        }

        this.refresh();
        this.sync();
      }

      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.observer?.disconnect();
      }

      step() {
        const first = this.slides[0];
        if (!first) return 1;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return Math.max(1, first.getBoundingClientRect().width + gap);
      }

      maxIndex() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        return Math.max(0, Math.round(max / this.step()));
      }

      refresh() {
        const max = this.maxIndex();
        this.dots.forEach((dot, i) => { dot.hidden = i > max; });
        this.readIndex();
      }

      readIndex() {
        const i = Math.round(this.track.scrollLeft / this.step());
        this.index = Math.min(Math.max(i, 0), this.maxIndex());
        this.dots.forEach((dot, di) => {
          if (di === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      go(i) {
        const max = this.maxIndex();
        let target = i;
        if (target > max) target = 0;
        if (target < 0) target = max;
        this.index = target;
        this.track.scrollTo({
          left: target * this.step(),
          behavior: this.reduced ? 'auto' : 'smooth'
        });
      }

      restart() {
        this.stop();
        this.sync();
      }

      sync() {
        const shouldRun = this.wantsAutoplay && !this.userPaused && !this.hovering && this.visible;
        if (shouldRun) this.start();
        else this.stop();
        this.track.setAttribute('aria-live', shouldRun ? 'off' : 'polite');
      }

      start() {
        if (this.timer) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }

      stop() {
        if (!this.timer) return;
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('ps-carousel', PsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tryphe-boton-fijo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tryphe-sticky-atc')) {
    class TrypheStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-tsatc-button]');
        this.label = this.querySelector('[data-tsatc-label]');
        this.originalLabel = this.label ? this.label.textContent : '';
        this.onScreen = new Set();
        this.tries = 0;
        this.button.addEventListener('click', () => this.addToCart());
        this.watchOriginals();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.clearTimeout(this.retryTimer);
        document.body.style.removeProperty('padding-bottom');
      }

      isUsable(node) {
        if (!node || this.contains(node)) return false;
        if (node.closest('header, footer, [class*="announcement"], tryphe-sticky-atc')) return false;
        return node.offsetParent !== null || node.getClientRects().length > 0;
      }

      bySelector(list) {
        const selectors = (list || '').split(',').map((s) => s.trim()).filter(Boolean);
        const found = [];
        selectors.forEach((selector) => {
          let nodes = [];
          try { nodes = Array.from(document.querySelectorAll(selector)); } catch (e) { return; }
          nodes.filter((n) => this.isUsable(n)).forEach((n) => found.push(n));
        });
        return found;
      }

      byText(text) {
        const needle = (text || '').trim().toLowerCase();
        if (!needle) return null;
        const groups = ['button, input[type="submit"], [role="button"]', 'a[href]'];
        for (const group of groups) {
          const match = Array.from(document.querySelectorAll(group)).find((node) => {
            const label = (node.innerText || node.value || node.getAttribute('aria-label') || '').toLowerCase();
            return label.includes(needle) && this.isUsable(node);
          });
          if (match) return match;
        }
        return null;
      }

      // Botones de la página que, si están en pantalla, esconden la barra.
      watchOriginals() {
        const gold = this.bySelector(this.dataset.targetSelector)[0] || this.byText(this.dataset.targetText);
        const others = this.bySelector(this.dataset.alsoHide);
        const watched = (gold ? [gold] : []).concat(others);

        if (!gold && this.tries < 20) {
          this.tries += 1;
          this.retryTimer = window.setTimeout(() => this.watchOriginals(), 500);
          if (!watched.length) return;
        }

        if (!watched.length) {
          this.toggle(true);
          return;
        }

        if (this.observer) this.observer.disconnect();
        this.onScreen.clear();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.onScreen.add(entry.target);
            else this.onScreen.delete(entry.target);
          });
          this.toggle(this.onScreen.size === 0);
        }, { threshold: 0 });
        watched.forEach((node) => this.observer.observe(node));
      }

      toggle(show) {
        if (show) {
          requestAnimationFrame(() => this.classList.add('is-visible'));
          if (getComputedStyle(this).display !== 'none') {
            document.body.style.paddingBottom = this.offsetHeight + 'px';
          }
        } else {
          this.classList.remove('is-visible');
          document.body.style.removeProperty('padding-bottom');
        }
      }

      setLabel(text) {
        if (this.label) this.label.textContent = text;
      }

      async addToCart() {
        if (this.button.disabled || this.busy) return;
        const id = Number(this.dataset.variantId);
        const quantity = Math.max(1, Number(this.dataset.quantity) || 1);
        if (!id) return;

        this.busy = true;
        this.button.setAttribute('aria-busy', 'true');
        this.setLabel(this.dataset.loadingText || this.originalLabel);

        try {
          const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity }] }),
          });
          if (!response.ok) throw new Error('cart add failed');

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          if (this.dataset.redirect) {
            window.location.href = this.dataset.redirect;
            return;
          }
          this.setLabel(this.originalLabel);
        } catch (error) {
          this.setLabel(this.dataset.errorText || this.originalLabel);
          window.setTimeout(() => this.setLabel(this.originalLabel), 2500);
        } finally {
          this.busy = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('tryphe-sticky-atc', TrypheStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-centeniall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vo-videos')) {
    class VoVideos extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.vo__card'));
        if (this.cards.length === 0) return;

        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.cards.forEach((card) => {
          const video = card.querySelector('[data-video]');
          const play = card.querySelector('[data-play]');
          const sound = card.querySelector('[data-sound]');
          if (!video) return;

          if (play) {
            play.addEventListener('click', () => {
              if (video.paused) this.play(card);
              else this.pause(card);
            }, opts);
          }

          if (sound) {
            sound.addEventListener('click', (event) => {
              event.stopPropagation();
              video.muted = !video.muted;
              sound.setAttribute('aria-pressed', String(video.muted));
              sound.setAttribute('aria-label', (video.muted ? 'Activar' : 'Silenciar') + ' el sonido de este video');
              if (!video.muted && video.paused) this.play(card);
            }, opts);
          }

          video.addEventListener('play', () => card.classList.add('is-playing'), opts);
          video.addEventListener('pause', () => card.classList.remove('is-playing'), opts);
          video.addEventListener('ended', () => card.classList.remove('is-playing'), opts);
        });

        if (this.dataset.mode === 'inview' && !this.reduced) {
          this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              const card = entry.target;
              if (entry.isIntersecting) this.play(card, true);
              else this.pause(card);
            }
          }, { threshold: 0.6 });
          this.cards.forEach((card) => this.observer.observe(card));
        }

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState !== 'visible') this.cards.forEach((card) => this.pause(card));
        }, opts);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      play(card, silent) {
        const video = card.querySelector('[data-video]');
        if (!video) return;
        if (!silent) {
          this.cards.forEach((other) => { if (other !== card) this.pause(other); });
        }
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch((error) => {
            // AbortError = lo pausamos a proposito mientras cargaba. No reintentar.
            if (!error || error.name !== 'NotAllowedError') return;
            video.muted = true;
            const sound = card.querySelector('[data-sound]');
            if (sound) {
              sound.setAttribute('aria-pressed', 'true');
              sound.setAttribute('aria-label', 'Activar el sonido de este video');
            }
            video.play().catch(() => {});
          });
        }
      }

      pause(card) {
        const video = card.querySelector('[data-video]');
        if (video && !video.paused) video.pause();
      }
    }

    customElements.define('vo-videos', VoVideos);
  }

  } catch(e) { console.error(e); }
})();
})();
